// extracted by mini-css-extract-plugin
export var accordion = "_fj-0";
export var chevron = "_fj-3";
export var closed = "_fj-2";
export var content = "_fj-4";
export var open = "_fj-1";
export var rotate = "_fj-5";